import { useId, type ComponentProps } from 'react';

import { InputLabel, Switch as OriginalSwitch } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type SwitchProps = ComponentProps<typeof OriginalSwitch> & {
  label?: string;
  infoIconWithTooltip?: string;
};

export const Switch = ({
  className,
  label,
  infoIconWithTooltip,
  ...rest
}: SwitchProps) => {
  const id = useId();

  return (
    <div
      className={cn(
        'flex items-center gap-2 [&_div]:first-of-type:pb-0',
        className,
      )}
    >
      <OriginalSwitch id={id} {...rest} />
      {label && (
        <InputLabel
          htmlFor={id}
          label={label}
          infoIconWithTooltip={infoIconWithTooltip}
        />
      )}
    </div>
  );
};
